import type { Campaign } from '~/modules/campaign/types';

import { getCampaignStatusInfo } from '~/modules/campaign';
import { GBadge } from '~/presentation/ui';

export interface GCampaignBadgeProps {
  status?: Campaign['status'];
  onlyIcon?: boolean;
}

export const GCampaignBadge = ({ status, onlyIcon }: GCampaignBadgeProps) => {
  const { name, badgeTone } = getCampaignStatusInfo(status);

  return <GBadge tone={badgeTone} progress="complete" children={onlyIcon ? '' : name} />;
};
